import MenuIcon from "@mui/icons-material/Menu";
import { Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { makeStyles } from "@mui/styles";
import React, { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Route, Switch } from "react-router-dom";
import HomePage from "../../pages/techOps/HomePage";
import LandingPage from "../../pages/LandingPage";
import NotFoundPage from "../../pages/NotFoundPage";
import { logout } from "../../util/authentication";
import {
  APPBAR_HEIGHT_PIXELS,
  DESKTOP_MIN_WIDTH_PIXELS,
  FEATURE_ACCESS_TYPE,
  HOME_PATH,
  TECH_OPS_FEATURES,
} from "../../util/constants";
// import { disconnect } from "../util/webSocketClient";
import EnvironmentChip from "../EnvironmentChip";
import HamburgerMenu from "../HamburgerMenu.jsx";
// import swaLogo from "../assets/Southwest_online_rgb_rev_cropped.png";
// import swaHeartLogo from '../assets/Southwest_Airlines_vector_logo.png';
import { clearAllReduxState } from "../../util/commonUtils";
import PageLoading from "../PageLoading";
import { getFeatureAccess } from "../../api/userAccess";
import TimecardForm from "../../pages/techOps/TimecardForm";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  appBar: {
    height: `${APPBAR_HEIGHT_PIXELS}px`,
  },
  toolbarMargin: theme.mixins.toolbar,
  userWelcomeAvatar: {
    color: theme.palette.primary.swaBlue,
    backgroundColor: theme.palette.secondary.swaWhite,
  },
  leftSide: {
    height: "inherit",
    justifyContent: "left",
    display: "flex",
    alignItems: "center",
  },
  techOpsLogo: {
    [theme.breakpoints.down("md")]: {
      fontSize: "15px",
    },
    marginLeft: "-75px",
    fontSize: "35px",
    cursor: "pointer",
  },
  chip: {
    [theme.breakpoints.down("md")]: {
      marginTop: "18px",
      marginLeft: "-79px",
    },
    marginLeft: "5px",
  },
  middle: {
    height: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  swaLogo: {
    [theme.breakpoints.down("md")]: {
      width: "100px",
    },
    width: "250px",
  },
  rightSide: {
    height: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },
}));

const MyToolbar = ({ classes, onMenuClick, userSession, isDesktopView }) => (
  <Fragment>
    <AppBar>
      <Toolbar>
        <Grid container className={classes.appBar}>
          <Grid item xs={4} className={classes.leftSide}>
            <IconButton color="inherit" aria-label="Menu" onClick={onMenuClick} size="large">
              <MenuIcon />
            </IconButton>
          </Grid>
          <Grid item xs={4} className={classes.middle}>
            {/* <img className={classes.swaLogo} src={isDesktopView ? swaLogo : swaHeartLogo} alt="Southwest Logo" /> */}
            <h1 className={classes.techOpsLogo} onClick={() => (window.location.href = `#${HOME_PATH}`)}>
              My Hours
            </h1>
            <div className={classes.chip}>
              <EnvironmentChip />
            </div>
          </Grid>
          {/* <Grid item xs={4} className={classes.rightSide}>
            <NotificationsPanel isDesktopView={isDesktopView} />
            <Avatar className={classes.userWelcomeAvatar}>
              {userSession.firstName.charAt(0) + userSession.lastName.charAt(0)}
            </Avatar>
          </Grid> */}
        </Grid>
      </Toolbar>
    </AppBar>
    <div className={classes.toolbarMargin} />
  </Fragment>
);

const AppBarInteraction = () => {
  const classes = useStyles();
  const isDesktopView = useMediaQuery({ minWidth: DESKTOP_MIN_WIDTH_PIXELS });
  const uri = window.location.hash;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("");
  const [openCascadeMenu, setOpenCascadeMenu] = useState({});
  const [userFeatures, setUserFeatures] = useState([]);
  const [isUserFeaturesLoading, setIsUserFeaturesLoading] = useState(true);

  useEffect(() => {
    fetchUserFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedMenuItem(uri.slice(1));
  }, [uri]);

  useEffect(() => {
    const menuItems = Object.values(userFeatures);

    let activeMenuItem = menuItems.find((menu) => menu.childItems.find((child) => child.path === uri.slice(1)));
    if (!!activeMenuItem) {
      setOpenCascadeMenu({ [activeMenuItem.key]: true });
    } else {
      setOpenCascadeMenu({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDrawerOpen]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleMenuItemClick = () => () => {
    setIsDrawerOpen(!isDrawerOpen);
    setOpenCascadeMenu({});
  };

  const handleParentMenuItemClick = (key) => {
    setOpenCascadeMenu({ [key]: !openCascadeMenu[key] });
  };

  const handleChildMenuItemClick = () => {
    toggleDrawer();
  };

  const logMeOut = async () => {
    try {
      toggleDrawer();
      clearAllReduxState();
      // disconnect();
    } catch (e) {
      console.error("Error during logout!");
    } finally {
      await logout();
    }
  };

  const fetchUserFeatures = () => {
    getFeatureAccess(FEATURE_ACCESS_TYPE.TO)
      .then((res) => res.json())
      .then((payload) => {
        setUserFeatures(payload.features);
        setIsUserFeaturesLoading(false);
      });
  };

  const getRouteForFeature = (feature) => {
    switch (feature.key) {
      case TECH_OPS_FEATURES.HOME:
        return (
          <Route
            key={feature.path}
            path={feature.path}
            render={(props) => (
              <HomePage {...props} userFeatures={Object.values(userFeatures)} isDesktopView={isDesktopView} />
            )}
          />
        );
      case TECH_OPS_FEATURES.FEATURE_1:
        return (
            <Route
              key={feature.path}
              path={feature.path}
              render={(props) => (
                <TimecardForm {...props} isDesktopView={isDesktopView}/>
              )}
            />
        );
      default:
        return "";
    }
  };

  const renderFeatureRoutes = () => {
    return (
      <main className={classes.root}>
        <Switch>
          <Route key="/" exact path="/" component={LandingPage} />
          {Object.values(userFeatures).map((feature) => {
            if (feature.childItems.length > 0) {
              return feature.childItems.map((child) => {
                return getRouteForFeature(child);
              });
            } else {
              return getRouteForFeature(feature);
            }
          })}
          <Route key="/*" path="/*" component={NotFoundPage} />
        </Switch>
      </main>
    );
  };
  return (
    <div className={classes.root}>
      {isUserFeaturesLoading ? (
        <PageLoading />
      ) : (
        <>
          <MyToolbar
            classes={classes}
            onMenuClick={toggleDrawer}
          />
          <HamburgerMenu
            open={isDrawerOpen}
            onClose={toggleDrawer}
            userFeatures={Object.values(userFeatures)}
            logMeOut={logMeOut}
            setSelectedMenuItem={setSelectedMenuItem}
            selectedMenuItem={selectedMenuItem}
            openCascadeMenu={openCascadeMenu}
            onMenuItemClick={handleMenuItemClick}
            onParentMenuItemClick={handleParentMenuItemClick}
            onChildMenuItemClick={handleChildMenuItemClick}
            isDesktopView={isDesktopView}
          />
          {renderFeatureRoutes()}
        </>
      )}
    </div>
  );
};

export default AppBarInteraction;